<script>
import { ValidationObserver } from 'vee-validate';
import { nextTick } from 'vue';
import BillingAccountAddressFields from './billing_account_address_fields.vue';

export default {
  name: 'BillingAccountAddressForm',
  components: {
    BillingAccountAddressFields,
    ValidationObserver,
  },
  props: {
    initialFormData: {
      type: Object,
      required: true,
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    showRequiredLabels: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      form: {
        address1: this.initialFormData.address1,
        address2: this.initialFormData.address2,
        country: this.initialFormData.country,
        state: this.initialFormData.state,
        city: this.initialFormData.city,
        zipCode: this.initialFormData.zipCode,
      },
    };
  },
  methods: {
    async handleFormValueChange(updatedForm) {
      this.form = updatedForm;
      // nextTick is needed because we need to wait for the ValidationObserver
      // be re-rendered before validating the form to get the latest validation state
      await nextTick();
      const isValid = await this.$refs.addressFormObserver?.validate({ silent: true });
      this.$emit('change', this.form, isValid);
    },
  },
  i18n: {
    title: 'Customer information',
  },
};
</script>

<template>
  <div data-testid="billing-account-address-form" class="jh-hidden">
    <h3 v-if="showHeader" class="gl-mb-5">{{ __($options.i18n.title) }}</h3>
    <validation-observer ref="addressFormObserver" slim>
      <billing-account-address-fields
        :initial-form-data="form"
        :show-required-labels="showRequiredLabels"
        @change="handleFormValueChange"
      />
    </validation-observer>
  </div>
</template>
